class SaTryOn extends HTMLElement {
  connectedCallback() {
    this.cards = [...this.querySelectorAll('[data-product-card]')];
    this.angles = [...this.querySelectorAll('[data-angle]')];
    this.state = {angle: 0, collection: 'All', type: 'All', selected: {}};
    this.angleNames = [this.dataset.frontLabel, this.dataset.rightLabel, this.dataset.backLabel, this.dataset.leftLabel];
    try { this.renders = JSON.parse(document.querySelector('[data-sa-renders]').textContent); } catch (e) { this.renders = {}; }
    Object.values(this.renders).forEach(list => list.forEach(src => { if (src) { const i = new Image(); i.src = src; } }));
    this.buildTabs('collection');
    this.buildTabs('type');
    this.bind();
    this.render();
  }

  buildTabs(kind) {
    const key = kind === 'collection' ? 'collection' : 'type';
    const target = this.querySelector(kind === 'collection' ? '[data-collection-tabs]' : '[data-type-tabs]');
    const values = ['All', ...new Set(this.cards.map(card => card.dataset[key]).filter(Boolean))];
    target.innerHTML = values.map((value, index) => '<button class="sa-tryon__tab' + (index === 0 ? ' is-active' : '') + '" type="button" data-filter="' + kind + '" data-value="' + this.escape(value) + '" aria-pressed="' + (index === 0) + '">' + this.escape(value) + '</button>').join('');
  }

  bind() {
    this.addEventListener('click', event => {
      const filter = event.target.closest('[data-filter]');
      if (filter) {
        this.state[filter.dataset.filter] = filter.dataset.value;
        filter.parentElement.querySelectorAll('[data-filter]').forEach(button => {
          const active = button === filter;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', active);
        });
        this.filterCards();
        return;
      }
      const card = event.target.closest('[data-product-card]');
      if (card) {
        const slot = card.dataset.slot;
        const current = this.state.selected[slot];
        if (current && current.card === card) {
          delete this.state.selected[slot];
        } else {
          const allVariants = JSON.parse(card.querySelector('[data-variants]').textContent);
          const colour = card.dataset.variantValue;
          const variants = colour ? allVariants.filter(variant => variant.options && variant.options.includes(colour)) : allVariants;
          this.state.selected[slot] = {card, variants: variants.length ? variants : allVariants};
        }
        this.render();
        return;
      }
      const rotate = event.target.closest('[data-rotate]');
      if (rotate) this.rotate(Number(rotate.dataset.rotate));
      const remove = event.target.closest('[data-remove]');
      if (remove) { delete this.state.selected[remove.dataset.remove]; this.render(); }
      if (event.target.closest('[data-add]')) this.addOutfit();
    });

    this.addEventListener('change', event => {
      const select = event.target.closest('[data-variant-select]');
      if (select) {
        const selection = this.state.selected[select.dataset.variantSelect];
        if (selection) selection.variantId = select.value;
        this.renderTotals();
      }
    });

    const stage = this.querySelector('[data-stage]');
    let start = null;
    stage.addEventListener('pointerdown', event => { if (event.target.closest('button')) return; start = event.clientX; });
    stage.addEventListener('pointermove', event => {
      if (start === null) return;
      const distance = event.clientX - start;
      if (Math.abs(distance) > 60) { this.rotate(distance < 0 ? 1 : -1); start = event.clientX; }
    });
    ['pointerup', 'pointerleave', 'pointercancel'].forEach(t => stage.addEventListener(t, () => { start = null; }));
  }

  rotate(direction) {
    this.state.angle = (this.state.angle + direction + this.angles.length) % this.angles.length;
    this.renderAngles();
  }

  filterCards() {
    this.cards.forEach(card => {
      const collectionMatch = this.state.collection === 'All' || card.dataset.collection === this.state.collection;
      const typeMatch = this.state.type === 'All' || card.dataset.type === this.state.type;
      card.hidden = !(collectionMatch && typeMatch);
    });
  }

  render() {
    this.cards.forEach(card => {
      const sel = this.state.selected[card.dataset.slot];
      const selected = !!sel && sel.card === card;
      card.classList.toggle('is-selected', selected);
      card.setAttribute('aria-pressed', selected);
    });
    this.renderAngles();
    this.renderSelections();
    this.filterCards();
  }

  currentRender() {
    const topSel = this.state.selected.top;
    const bottomSel = this.state.selected.bottom;
    const top = topSel ? topSel.card.dataset.handle : '';
    const bottom = bottomSel ? bottomSel.card.dataset.handle : '';
    const exact = this.renders[top + '|' + bottom];
    if (exact) return {list: exact, missing: false};
    const fallback = this.renders[(this.renders[top + '|'] ? top : '') + '|' + (this.renders['|' + bottom] ? bottom : '')] || this.renders['|'];
    return {list: fallback || [], missing: !!(top || bottom)};
  }

  renderAngles() {
    const current = this.currentRender();
    const list = current.list, missing = current.missing, self = this;
    this.angles.forEach((angle, angleIndex) => {
      const active = angleIndex === self.state.angle;
      angle.classList.toggle('is-active', active);
      angle.setAttribute('aria-hidden', String(!active));
      const img = angle.querySelector('[data-model]');
      const src = list[angleIndex === 3 ? 1 : angleIndex] || '';
      if (!src) return;
      img.dataset.want = src;
      if (img.getAttribute('src') === src) { img.classList.remove('is-swapping'); return; }
      const pre = new Image();
      pre.onload = () => { if (img.dataset.want === src) { img.src = src; img.classList.remove('is-swapping'); } };
      if (active && img.getAttribute('src')) img.classList.add('is-swapping');
      pre.src = src;
    });
    this.querySelector('[data-angle-label]').textContent = this.angleNames[this.state.angle];
    this.querySelector('[data-asset-note]').hidden = !missing;
  }

  renderSelections() {
    const target = this.querySelector('[data-selections]');
    const entries = Object.entries(this.state.selected);
    if (!entries.length) {
      target.innerHTML = '<p class="sa-tryon__empty">' + this.escape(this.dataset.emptyLabel) + '</p>';
      this.renderTotals();
      return;
    }
    target.innerHTML = entries.map(pair => {
      const slot = pair[0], selection = pair[1];
      const variants = selection.variants;
      if (!selection.variantId) {
        const preferred = variants.find(variant => variant.available) || variants[0];
        selection.variantId = String(preferred.id);
      }
      const options = variants.map(variant => '<option value="' + variant.id + '"' + (String(variant.id) === String(selection.variantId) ? ' selected' : '') + (variant.available ? '' : ' disabled') + '>' + this.escape(variant.title) + (variant.available ? '' : ' — ' + this.escape(this.dataset.soldOutLabel)) + '</option>').join('');
      return '<div class="sa-tryon__selection"><strong>' + this.escape(selection.card.dataset.title) + '</strong><select data-variant-select="' + slot + '" aria-label="' + this.escape(selection.card.dataset.title) + '">' + options + '</select><button class="sa-tryon__remove" type="button" data-remove="' + slot + '" aria-label="' + this.escape(this.dataset.removeLabel) + ' ' + this.escape(selection.card.dataset.title) + '">&#215;</button></div>';
    }).join('');
    this.renderTotals();
  }

  renderTotals() {
    const entries = Object.values(this.state.selected);
    let total = 0;
    entries.forEach(selection => {
      const variant = selection.variants.find(item => String(item.id) === String(selection.variantId));
      total += Number((variant && variant.price) || 0);
    });
    const currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'GBP';
    this.querySelector('[data-total]').textContent = new Intl.NumberFormat('en-GB', {style: 'currency', currency: currency}).format(total / 100);
    this.querySelector('[data-item-count]').textContent = entries.length + ' ' + (entries.length === 1 ? this.dataset.itemLabel : this.dataset.itemsLabel);
    this.querySelector('[data-add]').disabled = entries.length === 0;
  }

  async addOutfit() {
    const button = this.querySelector('[data-add]');
    const status = this.querySelector('[data-status]');
    const items = Object.values(this.state.selected).map(selection => ({id: Number(selection.variantId), quantity: 1}));
    if (!items.length) return;
    button.disabled = true;
    button.textContent = this.dataset.addingLabel;
    status.textContent = '';
    try {
      const response = await fetch('/cart/add.js', {method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify({items})});
      if (!response.ok) throw new Error('Cart request failed');
      button.textContent = 'Added ✓';
      document.dispatchEvent(new CustomEvent('sa:cart:added'));
      setTimeout(() => { button.disabled = false; button.textContent = this.dataset.addLabel; }, 1500);
    } catch (error) {
      status.textContent = this.dataset.errorLabel;
      button.disabled = false;
      button.textContent = this.dataset.addLabel;
    }
  }

  escape(value) {
    const node = document.createElement('span');
    node.textContent = value || '';
    return node.innerHTML;
  }
}
if (!customElements.get('sa-try-on')) customElements.define('sa-try-on', SaTryOn);